export enum BulkUploadType {
  Users = 'Users',
  FreemiumUsers = 'FreemiumUsers'
}

